export default "__VITE_ASSET__C2FW5b3E__"